import { useEffectOnce } from 'react-use';

import {
  ReadNumbersPaginatedOptions,
  ReadNumbersPaginatedPublicArg,
  ReadNumbersPaginatedResult,
  useLazyReadNumbersPaginatedQuery,
} from '../useLazyReadNumbersPaginatedQuery';

type UseReadNumbersPaginatedQueryOptions = ReadNumbersPaginatedOptions & {
  readonly initialArg: ReadNumbersPaginatedPublicArg;
};

/**
 * Eager variant of {@link useLazyReadNumbersPaginatedQuery}. Triggers a fetch on
 * mount with the given `initialArg`.
 */
export const useReadNumbersPaginatedQuery = ({
  initialArg,
  ...options
}: UseReadNumbersPaginatedQueryOptions): ReadNumbersPaginatedResult => {
  const result = useLazyReadNumbersPaginatedQuery(options);

  useEffectOnce(() => {
    result.changeArg(initialArg);
  });

  return result;
};
